import React from 'react';
import './Symptoms.scss';
import IconList from '../../components/IconList/IconList';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import iconOne from '../../assets/symptoms/1.png';
import iconTwo from '../../assets/symptoms/2.png';
import iconThree from '../../assets/symptoms/3.png';
import iconFour from '../../assets/symptoms/4.png';
import iconFive from '../../assets/symptoms/5.png';

const Symptoms = () => {
    const symptomsData = [
        {
            'icon' : iconOne,
            'title' : 'Spontaneous pain',
            'description':'Spontaneous pain even when youre not eating or drinking' 
        },
        {
            'icon' : iconTwo,
            'title' : 'Discoloration of tooth',
            'description':'Darkening or discoloration of a tooth' 
        },
        {
            'icon' : iconThree,
            'title' : 'Middle night pain',
            'description':'Pain that wakes you up in the middle of the night' 
        },
        {
            'icon' : iconFour,
            'title' : 'Tenderness in gums',
            'description':'From floss bosses to sweet tooths, every mouth is welcome.' 
        },
        {
            'icon' : iconFive,
            'title' : 'Extreme sensitivity',
            'description':'Extreme sensitivity to cold or heat when you eat or drink' 
        }
    ]

    return (
        <section className='symptoms-section section-common pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <SectionTitle 
                    subTitle="Symptoms"
                    title="Sign and symptoms you need root canal"
                    description="Here are some common symptoms that may indicate a need for a root canal treatment:"
                />

                <div className="row">
                    {
                        symptomsData.map(singleSymptoms => 
                            <IconList 
                                icon={singleSymptoms.icon}
                                title={singleSymptoms.title}
                                description={singleSymptoms.description}
                            />
                        )
                    }
                </div>

                <div className="row">
                    <div className="col-12 text-center mt-5">
                        <div className="symptoms-cta">
                            <p className="cta-text">
                                If you're experiencing any of these symptoms, don't wait. Early treatment can save your tooth and prevent further complications.
                            </p>
                            <a 
                                href='https://www.recomed.co.za/dentist/cape-town/mishqah-dollie/7579/7349/' 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="btn-primary"
                                aria-label="Book your root canal consultation with Dr Mishqah Dollie in Ottery, Cape Town"
                            >
                                Book Root Canal Consultation
                                <BsFillArrowRightCircleFill aria-hidden="true"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Symptoms;